module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.3f84d643.png";